"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConditionReverseDensity = exports.isConditionWaitingTime = exports.isConditionAtmosphere = exports.isConditionNotStatus = exports.isConditionStatus = exports.isConditionIntrusion = exports.isConditionFlux = exports.isConditionStopngoLimit = exports.isConditionLimit = exports.ConditionDirection = exports.ConditionType = void 0;
var ConditionType;
(function (ConditionType) {
    ConditionType["LIMIT"] = "limit";
    ConditionType["STOPNGO_LIMIT"] = "stopngoLimit";
    ConditionType["FLUX"] = "flux";
    ConditionType["INTRUSION"] = "intrusion";
    ConditionType["STATUS"] = "status";
    ConditionType["TEMPERATURE"] = "temperature";
    ConditionType["HUMIDITY"] = "humidity";
    ConditionType["CO2"] = "co2";
    ConditionType["WAITING_TIME"] = "waitingTime";
    ConditionType["REVERSE_DENSITY"] = "reverseDensity";
    ConditionType["COMFORT_SCALE"] = "comfortScale";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
var ConditionDirection;
(function (ConditionDirection) {
    ConditionDirection["IN"] = "in";
    ConditionDirection["OUT"] = "out";
})(ConditionDirection = exports.ConditionDirection || (exports.ConditionDirection = {}));
// Type guards
var isConditionLimit = function (condition) { return condition.type === ConditionType.LIMIT; };
exports.isConditionLimit = isConditionLimit;
var isConditionStopngoLimit = function (condition) { return condition.type === ConditionType.STOPNGO_LIMIT; };
exports.isConditionStopngoLimit = isConditionStopngoLimit;
var isConditionFlux = function (condition) { return condition.type === ConditionType.FLUX; };
exports.isConditionFlux = isConditionFlux;
var isConditionIntrusion = function (condition) { return condition.type === ConditionType.INTRUSION; };
exports.isConditionIntrusion = isConditionIntrusion;
var isConditionStatus = function (condition) { return condition.type === ConditionType.STATUS; };
exports.isConditionStatus = isConditionStatus;
var isConditionNotStatus = function (condition) {
    return condition.type !== ConditionType.STATUS;
};
exports.isConditionNotStatus = isConditionNotStatus;
var isConditionAtmosphere = function (condition) {
    return condition.type === ConditionType.CO2 || condition.type === ConditionType.TEMPERATURE || condition.type === ConditionType.HUMIDITY;
};
exports.isConditionAtmosphere = isConditionAtmosphere;
var isConditionWaitingTime = function (condition) { return condition.type === ConditionType.WAITING_TIME; };
exports.isConditionWaitingTime = isConditionWaitingTime;
var isConditionReverseDensity = function (condition) { return condition.type === ConditionType.REVERSE_DENSITY; };
exports.isConditionReverseDensity = isConditionReverseDensity;
